import React, { useState, useEffect} from "react";

import {Button,Table,Card,CardHeader,CardBody,Container,Row,Col,} from "reactstrap";
import DepositToShop from "views/seller/DepositToShop";
import OpenOrders from "./OpenOrders";
import NextEventsOwed from "./NextEventsOwed";

const Index = (props) => {

  useEffect(() => {
  }, []);

  const id = JSON.parse(localStorage.getItem('user'))._id
  const role = JSON.parse(localStorage.getItem('user')).role

  
    return (
      <>
        {/* Page content */}
        <Container fluid>
            
          <Row>
            <Col className="mb-5 mb-xl-0" xl="12">
              <Card className="bg-gradient-default shadow">
                <CardHeader className="bg-transparent">
                  <Row className="align-items-center">
                    <div className="col">
                      <h2 className="text-white mb-0">Open Orders</h2>
                    </div>
                  </Row>
                </CardHeader>
                <CardBody>
                  <OpenOrders/>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col className="mb-5 mb-xl-0" xl="8">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <div className="col">
                      <h3 className="mb-0">Next 3 events with money owed</h3>
                    </div>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Col className="ml-2">
                    <NextEventsOwed/>
                  </Col>

                </CardBody>
                
              </Card>
            </Col>
            <Col xl="4">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <div className="col">
                      <h3 className="mb-0">Owed</h3>
                    </div>
                    <div className="col text-right">
                      <DepositToShop reseller={true}/>
                    </div>
                  </Row>
                </CardHeader>
                
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  
}

export default Index;
